    $(function () {

        var contentSelector = document.getElementById("content-selector");
        if (!contentSelector) {
            return;
        }

        $("#journal-link").on("click", function () {
            $("#book-list").collapse("hide");
            $("#journal-list").collapse("show");
        });

        $("#book-link").on("click", function () {
            $("#journal-list").collapse("hide");
            $("#book-list").collapse("show");
        });

        $(".panel-collapse").on("hide.bs.collapse", function () {
            $(this).closest(".panel").find(".collapse-button.icon-container").removeClass("active");
        });

        $(".panel-collapse").on("show.bs.collapse", function () {
            $(this).closest(".panel").find(".collapse-button.icon-container").addClass("active");

            var linkId = $(this).data("link");
            if (linkId) {
                $("#content-switch").children().removeClass("active");
                $(linkId).addClass("active");
            }
        });

        var mobileWidth = "767px",
            resizeTimer, 
            state = "";

        var adjustPanel = function () {
                if (Modernizr.mq("(min-width: " + mobileWidth + ")")) {
                    // to desktop
                    if (state !== "desktop") {
                        $(".tab-link.active").click();
                        $("#special-book-collection-list").collapse("show");
                    }

                    state = "desktop";
                } else if (Modernizr.mq("(max-width: " + mobileWidth + ")")) {
                    // to mobile
                    if (state !== "mobile") {
                        $(".panel-collapse").removeClass("in");
                        $("[aria-expanded=true]").attr("aria-expanded", false);
                        $(".panel").find(".collapse-button.icon-container").removeClass("active");
                    }

                    state = "mobile";
                }
        }

        adjustPanel();

        $(window).on("resize", function () {
            clearTimeout(resizeTimer);

            resizeTimer = setTimeout(function () {

                adjustPanel();
            }, 100);
        });
    });